module.exports = __webpack_public_path__ + "img/sonepar.4cfc6c0f.png";